import React from "react";
import PropTypes from "prop-types";

const PersonDetails = ({
  bio,
  email,
  linkedin,
  name,
  phoneNumber,
  title,
  twitter,
  twitterUrl
}) => (
  <div className="m-show-description">
      {title ? (
        <h3 className="s-people-name"> {name}, {title} </h3>
      ) : (
        <h3 className="s-people-name"> {name} </h3>
      )}
    <div className="s-person-show-email">
      {email ? (
        <a
          href={`mailto:${email}`}
          target="_blank"
          title={email}
          className="noline"
          rel="noopener noreferrer"
        >
          <span className="bff-email icon" aria-label="email" />
          <span className="person-info">{email}</span>
        </a>
      ) : (
        ""
      )}
      {phoneNumber ? (
        <a
          href={`tel:${phoneNumber}`}
          target="_blank"
          title={phoneNumber}
          className="noline phone-number"
          rel="noopener noreferrer"
        >
          <span className="bff-phone icon" aria-label="phone" />
          <span className="person-info">{phoneNumber}</span>
        </a>
      ) : (
        ""
      )}
      {twitter ? (
        <a
          href={twitterUrl}
          target="_blank"
          title={`Twitter: @${twitter}`}
          className="noline"
          rel="noopener noreferrer"
        >
          <span className="bff-twitter-icon icon" aria-label="Twitter" />
          <span className="person-info">{twitter}</span>
        </a>
      ) : (
        ""
      )}

      {linkedin ? (
        <a
          href={linkedin}
          target="_blank"
          title="LinkedIn"
          className="noline"
          rel="noopener noreferrer"
        >
          <span className="bff-linked-in icon" arial-label="LinkedIn" />
          <span>{linkedin}</span>
        </a>
      ) : (
        ""
      )}
    </div>
    <hr className="s-people-line-break" />
    {bio ? (
      <div className="m-show-description s-asset-description">
        <span className="s-asset-details-title modal-label">
          {bfTranslate("Description")}
        </span>
        {bio}
      </div>
    ) : (
      ""
    )}
  </div>
);

PersonDetails.propTypes = {
  bio: PropTypes.string,
  email: PropTypes.string,
  linkedin: PropTypes.string,
  name: PropTypes.string,
  phoneNumber: PropTypes.string,
  title: PropTypes.string,
  twitter: PropTypes.string,
  twitterUrl: PropTypes.string
};

export default PersonDetails;
